<div class="container-fluid mt-3">
  <!-- Filters -->
  <div class="row g-3 mb-4 align-items-end">
    <div class="col-md-2">
      <label class="form-label">{{ "Amendment From" | translate }}</label>
      <p-calendar
        inputId="calendar-from"
        [(ngModel)]="filters.amendmentFrom"
        [readonlyInput]="true"
        [dateFormat]="date"
        (onSelect)="onFilterChange()"
        styleClass="custom-calendar"
      />
    </div>
    <div class="col-md-2">
      <label class="form-label">{{ "Amendment To" | translate }}</label>
      <p-calendar
        inputId="calendar-to"
        [(ngModel)]="filters.amendmentTo"
        [readonlyInput]="true"
        [dateFormat]="date"
        (onSelect)="onFilterChange()"
        styleClass="custom-calendar"
      />
    </div>
    <div class="col-md-2">
      <label class="form-label">{{ "Module" | translate }}</label>
      <ng-select
        [items]="modules"
        [(ngModel)]="filters.module"
        [placeholder]="'All' | translate"
        [clearable]="!!filters.module"
        (change)="onFilterChange()"
      >
      </ng-select>
    </div>
    <div class="col-md-2">
      <label class="form-label">{{ "search" | translate }}</label>
      <input
        type="text"
        class="form-control form-control-sm"
        [placeholder]="'Search' | translate"
        [(ngModel)]="filters.searchText"
        (ngModelChange)="onFilterChange()"
      />
    </div>
    <div class="col-md-4 d-flex align-items-end justify-content-end">
      <div class="export-three-dot-menu">
        <button class="export-menu-button" (click)="toggleMenu()">
          &#8942;
        </button>
        <div *ngIf="isMenuOpen" class="export-menu-dropdown">
          <button class="export-menu-item" (click)="exportToExcel()">
            {{ "Export to Excel" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-responsive">
    <app-custom-table
      [listData]="logs"
      [selectedColumns]="myColumns"
      [menuId]="menuId"
      [moduleKey]="'audit'"
      [tableName]="'Audit Report'"
      [totalRecords]="totalRecords"
      [page]="page"
      [pageSize]="pageSize"
      [sectionid]="menuId"
      [angularDateFormat]="angularDateFormat"
      [dateFormat]="dateFormat"
      [disableAction]="true"
      (pageChanges)="handleFilterChange($event)"
    >
    </app-custom-table>
  </div>

  <!-- Pagination -->
  <div class="d-flex justify-content-center py-3">
    <ngb-pagination
      *ngIf="logs.length != 0"
      class="pagination-master"
      [maxSize]="pageSize"
      [collectionSize]="totalRecords"
      [(page)]="page"
      [pageSize]="pageSize"
      [rotate]="true"
      [ellipses]="false"
      [boundaryLinks]="true"
      (pageChange)="handlePageChange($event)"
    >
    </ngb-pagination>
  </div>
</div>
